import { Logout, SetUserDataLoaded } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { UserDataState } from './types'

const getInitialState = (): UserDataState => ({
  isUserDataLoaded: false,
})

export const userDataReducer = (
  state: UserDataState = getInitialState(),
  action: Action<any>,
): UserDataState => {
  switch (action.type) {
    case SetUserDataLoaded.type.SUCCESS:
      return {
        ...state,
        isUserDataLoaded: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
